import React from 'react';
import { useTranslation } from 'react-i18next';
import useAuth from '../../hooks/useAuth';  // 2 níveis acima (pages -> src -> hooks)
import './profille.css';

const Profile = () => {
  const { user, signout } = useAuth();
  const { t } = useTranslation();

  if (!user) {
    return <div>{t('profile.loading')}</div>;
  }

  return (
    <div className="profile-container">
      <h1>{t('profile.title')}</h1>
      <div className="profile-info">
        <p>{t('profile.name')}: {user.name}</p>
        <p>{t('profile.email')}: {user.email}</p>
      </div>
      <button onClick={signout} className="logout-button">
        {t('profile.logout')}
      </button>
    </div>
  );
};

export default Profile;